
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class VendorService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.ven_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_VENDOR_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getVendorPageList(input, responseCallBack, errorCallBack) {
    this.method("getVendorPageList", input, responseCallBack, errorCallBack);
  }
  static readVendor(input, responseCallBack, errorCallBack) {
    this.method("readVendor", input, responseCallBack, errorCallBack);
  }
  static initVendorModule(input, responseCallBack, errorCallBack) {
    this.method("initVendorModule", input, responseCallBack, errorCallBack);
  }
  static unLockVendor(input, responseCallBack, errorCallBack) {
    this.method("unLockVendor", input, responseCallBack, errorCallBack);
  }
  static saveVendor(input, responseCallBack, errorCallBack) {
    this.method("saveVendor", input, responseCallBack, errorCallBack);
  }
  static updateVendor(input, responseCallBack, errorCallBack) {
    this.method("updateVendor", input, responseCallBack, errorCallBack);
  }
  static getVendorPurchaseOnOrderDetailsForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getVendorPurchaseOnOrderDetailsForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getVendorFactoryPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getVendorFactoryPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readVendorFactory(input, responseCallBack, errorCallBack) {
    this.method("readVendorFactory", input, responseCallBack, errorCallBack);
  }
  static saveVendorFactory(input, responseCallBack, errorCallBack) {
    this.method("saveVendorFactory", input, responseCallBack, errorCallBack);
  }
  static updateVendorFactory(input, responseCallBack, errorCallBack) {
    this.method("updateVendorFactory", input, responseCallBack, errorCallBack);
  }
  static getInTransitSummaryDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getInTransitSummaryDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getVendorPurchaseOnOrderDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getVendorPurchaseOnOrderDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.ven_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     //"Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.ven_data_url,responseCallBack, errorCallBack);
    }
  }
}
